module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"document":"Número do documento"},"en-US":{"document":"Document  number"}}')
  delete Component.options._Ctor
}
